/// <reference path="common/istateoptions.d.ts" />
/// <reference path="../../typings/index.d.ts" />
/// <reference path="apimodel.d.ts" />
/// <reference path="app.module.ts" />
/// <reference path="common/services/validationelementmodifierservice.ts" />
/// <reference path="common/services/validationerrormessageresolverservice.ts" />
/// <reference path="common/services/navigationhelperservice.ts" />

((() => {
	'use strict';

	angular
		.module('app')
		.run([
			'$rootScope',
			'$state',
			'$q',
			'$window',
			'$sessionStorage',
			'validator',
			'app.common.services.globalSettingsService',
			'app.common.services.navigationHelperService',
			'app.common.services.authenticationService',
			'app.common.services.validationElementModifierService',
			'app.common.services.validationErrorMessageResolverService',
			'app.common.services.guidService', (
				$rootScope: angular.IRootScopeService,
				$state: angular.ui.IStateService,
				$q: angular.IQService,
				$window: angular.IWindowService,
				$sessionStorage: App.Common.ISessionStorage,
				validator: any,
				globalSettings: App.Common.Services.GlobalSettingsService,
				navigationHelper: App.Common.Services.NavigationHelperService,
				authentication: App.Common.Services.AuthenticationService,
				validationElementModifierService: App.Common.Services.ValidationElementModifierService,
				validationErrorMessageResolverService: App.Common.Services.ValidationErrorMessageResolverService,
				guid: App.Common.Services.GuidService) => {

				if (!$sessionStorage.windowId) {
					$sessionStorage.windowId = guid.newGuid();
				}

				navigationHelper.init();

				//Configure angular-auto-validation
				validator.registerDomModifier(validationElementModifierService.key, validationElementModifierService);
				validator.setDefaultElementModifier(validationElementModifierService.key);
				validator.setErrorMessageResolver(validationErrorMessageResolverService.resolve);
				validator.defaultFormValidationOptions = {
					forceValidation: false,
					disabled: false,
					validateNonVisibleControls: false,
					removeExternalValidationErrorsOnSubmit: true,
					validateOnFormSubmit: true,
					waitForAsyncValidators: true
                };

                function silenceUncaughtInPromise(promise) {
                    return promise.then(undefined, function () { }) && promise;
                }

				//Wrap $state.transitionTo() to fire a new event before state change
				//in order to allow navigation cancellation without breaking the browser's history stack
				var transitionTo = $state.transitionTo;
				$state.transitionTo = (state: angular.ui.IState, params?: {}, options?: App.Common.IStateOptions): angular.IPromise<any> => {

					var from = $state.current, fromParams = $state.params;
					state = state && state.name ? state : $state.get(state);

					if ((!options || options.notify !== false)
						&& $rootScope.$broadcast('$beforeStateChange', state, params, from, fromParams, options).defaultPrevented) {
                        return silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
					} else {
						return transitionTo(state, params, options);
					}
				};
			}
		]);

})());